/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { lazy, ReactElement, Suspense, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { getAllUserPlates } from '../api/user_plates'
import * as LoadingStates from '../constants/LoadingStates'
import platePage from '../data/plates.json'
import libriosLink from '../data/librios_links.json'

interface IProps {
  loadingState: string
}

interface IPlateData {
  librios_plate_id: number
  title: string
  colors: {
    [key: string]: string
  }
}

const ThumbnailLoader: React.FC<IProps> = ({ loadingState }) => {
  const [searchParams] = useSearchParams({ token: '' })
  const [userPlates, setUserPlates] = useState([])
  const domain = new URL(document.referrer)

  useEffect(() => {
    const token = searchParams.get('token')
    if (token !== null) {
      getAllUserPlates(token).then((response) => {
        setUserPlates(response.data)
      })
    }
  }, [searchParams])

  const getPlates = (): (JSX.Element | null)[] => {
    const PlateComponents = userPlates.map((userPlate: IPlateData) => {
      const plateId = userPlate.librios_plate_id.toString()
      const plateEnv =
        platePage[process.env.REACT_APP_ENVIRONMENT as keyof typeof platePage]
      const plate = plateEnv[plateId as keyof typeof plateEnv]

      const linkEnv =
        libriosLink[
          process.env.REACT_APP_ENVIRONMENT as keyof typeof libriosLink
        ]
      const link = linkEnv[plateId as keyof typeof linkEnv]
      if (plate !== undefined) {
        const PlateComponent = lazy(
          () => import(`../components/thumbnails/${plate}`),
        )

        return (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <a
              href={`${domain.origin}${link}?tab=create`}
              target="_top"
              rel="noreferrer"
              style={{
                color: '#006c86',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '1.5rem',
                letterSpacing: '0.001rem',
              }}
            >
              <PlateComponent key={plateId} colors={userPlate.colors} />
              {userPlate.title}
            </a>
          </div>
        )
      }
      return null
    })

    return PlateComponents
  }

  const getLoadedState = (): ReactElement => {
    switch (loadingState) {
      case LoadingStates.LOADING:
        return <div>Loading plates</div>
      case LoadingStates.AUTHENTICATED:
        return (
          <Suspense fallback={<div>Loading...</div>}>
            <div
              style={{
                display: 'inline-flex',
                flexWrap: 'wrap',
              }}
            >
              {getPlates()}
            </div>
          </Suspense>
        )
      case LoadingStates.DENIED:
        return <div>Not Logged In.</div>
      case LoadingStates.NOTIFRAME:
        return (
          <div>This workspace can only be viewed on the Librios platform.</div>
        )
      default:
        return <div>There was an error</div>
    }
  }

  return <div>{getLoadedState()}</div>
}

export default ThumbnailLoader
